import { useEffect, useRef, useState } from "react"
import { useReactToPrint } from "react-to-print"
import { useTranslation } from "react-i18next"
import { FetchCounterValueItem } from "./FetchCounterValueItem"
import openIcon from "./selecticon.png"
import { IFetchCounterValue } from "@types"
import { SkeletonLoader } from "components"
import { useActionsFetchCounterValuesQuery } from "../../store/Features/actions/actionsFetchCounterValues-api-slice"

export const FetchCounterValue = () => {
 // language translator
 const { t } = useTranslation("translation")
 const { data, isLoading } = useActionsFetchCounterValuesQuery()
 const [selectedData, setSelectedData] = useState<IFetchCounterValue[]>([])
 const [startIndex, setStartIndex] = useState(0)
 const componentRef = useRef(null)

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
 }, [data])
 const cardsPerPage = 3

 const handleNext = () => {
  if (startIndex + cardsPerPage < selectedData.length) {
   setStartIndex(startIndex + cardsPerPage)
  }
 }

 const handlePrev = () => {
  if (startIndex - cardsPerPage >= 0) {
   setStartIndex(startIndex - cardsPerPage)
  }
 }
 // splitting array
 const Allcards = selectedData.slice(startIndex, startIndex + cardsPerPage)

 // method for printing the devices status
 const handlePrint = useReactToPrint({
  content: () => componentRef.current,
 })

 return (
  <div>
   <div className="flex justify-between items-center w-[98%] mx-auto py-4 ">
    <h1 className="font-semibold text-2xl">{t("fetchCounterValue")}</h1>
    <div className="lg:w-[18%] flex lg:justify-between items-center">
     <button
      className="bg-dark-yellow px-6 py-1 font-semibold  rounded hover:bg-[#FED749] hover:text-white "
      onClick={() => {
       handlePrint()
      }}
     >
      {t("print")}
     </button>
     <div className="flex lg:w-[35%] justify-between">
      <button
       onClick={handlePrev}
       disabled={startIndex === 0}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex === 0 ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
      </button>
      <button
       disabled={startIndex + cardsPerPage >= selectedData.length}
       onClick={handleNext}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex + cardsPerPage >= selectedData.length ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-90" src={openIcon} alt="next" />
      </button>
     </div>
    </div>
   </div>

   <div
    ref={componentRef}
    className="flex lg:flex-row flex-col gap-3 overflow-x-scroll  hide-scroll-icon"
   >
    {isLoading ? (
     <div className="w-[98%] mx-auto">
      <SkeletonLoader count={6} />
     </div>
    ) : (
     Allcards.map((item, index) => (
      <div key={index} className="min-w-[45%] ">
       {/* =========== FetchCounterValueItem component for removing duplicates ====== */}
       <FetchCounterValueItem item={item} index={index} />
      </div>
     ))
    )}
   </div>
  </div>
 )
}
